document.addEventListener("DOMContentLoaded", () => {
	let button = document.getElementById("load-more-posts");
	let postsContainer = document.getElementById("extra-posts-container");

	if (!button) return;

	button.addEventListener("click", () => {
		const offset = parseInt(button.dataset.offset);
		const categoryId = button.dataset.categoryId || "";
		const isCategory = button.dataset.isCategory || "0";

		const formData = new FormData();
		formData.append("action", "load_more_posts");
		formData.append("offset", offset);
		formData.append("category_id", categoryId);
		formData.append("is_category", isCategory);

		fetch(ajax_object.ajax_url, {
			method: "POST",
			body: formData,
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.html.trim() !== "") {
					postsContainer.insertAdjacentHTML("beforeend", data.html);
					button.dataset.offset = offset + data.count;

					if (data.count < 5) {
						button.remove();
					}
				} else {
					button.remove();
				}
			})
			.catch((error) => console.error("Ошибка загрузки:", error));
	});
});
